import React, { Component } from 'react';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import FetchCall from '../../API/FetchCall';
import { getAllPresSchools, schoolSecondFilter, catgoryList, getSchoolCategoryIdBySlug, saveEnqLead } from '../../API/FetchCall';
import { Link } from 'react-router-dom';
//import { TopTrending } from '../Banner/topTrending';
import { TopTrending } from '../Banner/topTrending';
import { LeadSmall } from "../Banner/LeadSmall";
import {ArticleSmall} from "../Banner/ArticleSmall";

import ReactTooltip from "react-tooltip";
import Rating from 'react-star-rating-component';
import {
  BASE_URL, RATING_GOOGLE, PAGI_PERPAGE, MAXDIS_FIL,AZ_ASSET_PATH,
  MAXFEE_FIL, FIL_DIS, MAXDIS_FILP, IMG_URL, SCREEN_SIZE,
  FIL_FEEP, MAXFEE_FILPlay, CENTERLAT, CENTERLNG, PAGINATION_LBL, DEFAULT_DIS, DEFAULT_FEE, DEFAULT_FEE_OTHER
} from '../../constant';
import { AdsDynamicMobileMiddle, AdsHorizandal, AdsVertical, AdsDynamicRightPosition1,AdsDynamicRightPosition2, AdsDynamicBottom, AdsDynamicRightPosition980} from '../../components/others/ads';
import { SchoolRight } from '../../components/others/ads_vertical_landing';
import JwPagination from 'jw-react-pagination';
import $ from 'jquery';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import Geocode from "react-geocode";

import { Modal, ModalBody } from 'reactstrap';

import { Helmet } from 'react-helmet';

//import { ReactSession }  from 'react-client-session';


import closebtn from '../../../src/assets/icons/close.svg';

import '../../../src/assets/css/custom.css';
import '../../../src/assets/css/mobile.css';
import '../../../src/assets/css/customV1.css';
/*
const searchOptions = {
  location: new google.maps.LatLng('77.5946', '12.9716'),
  radius: 15000,
  types: ['address']
}
*/

import CardSkeleton from './CardSkeleton';
import meta_function from '../../meta_data';
import { verticalTotalCount, verticalListing, verticalSeoContent } from '../../API/FetchCall';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import actionicon1 from "./../../assets/icons/v2/compare.png";
import actionicon3 from "./../../assets/icons/v2/wishlist.png";

import compareicon from "./../../assets/icons/balance.png";
import stampedicon from "./../../assets/icons/stamps/stamp.png";


import filtericon from '../../../src/assets/icons/filter.png';

import clickhereanim from '../../../src/assets/icons/click-here-animation.gif';

import { addToWishList, addToCompareList } from '../../common.js';

import AllVerticalSte1 from "../Leads/verticalStep1";

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

const filtertitle = 'Use Below Filters for Best Results';

class SchoolPage extends Component {
  constructor(props) {
    super(props);
    let centerLocation = 'MG road Bangalore';
    if (this.props.match.params.city == 'chennai') {
      centerLocation = 'Nungambakkam Chennai';
    }
    let meta = meta_function.get_meta_data('scl', this.props.match.params.subcategory, this.props.match.params.city);

    sessionStorage.clear();

    if (!sessionStorage.getItem('filtered_pages')) {
      sessionStorage.setItem('filtered_pages', '');
    }

    // if(!sessionStorage.getItem('thispagehash')){
    //     sessionStorage.setItem('thispagehash', thispagehash);
    //  }

    if (!sessionStorage.getItem('curriculam_texts')) {
      sessionStorage.setItem('curriculam_texts', '');
      sessionStorage.setItem('curriculam_ids', '');
    }

    if (!sessionStorage.getItem('type_texts')) {
      sessionStorage.setItem('type_texts', '');
      sessionStorage.setItem('type_ids', '');
    }

    if (!sessionStorage.getItem('location_texts'))
      sessionStorage.setItem('location_texts', '');

    if (!sessionStorage.getItem('fees_texts'))
      sessionStorage.setItem('fees_texts', '');

    if (!sessionStorage.getItem('ratings_texts'))
      sessionStorage.setItem('ratings_texts', '');

    if (!sessionStorage.getItem('googleratings_texts'))
      sessionStorage.setItem('googleratings_texts', '');

    if (!sessionStorage.getItem('facilities_texts')) {
      sessionStorage.setItem('facilities_texts', '');
      sessionStorage.setItem('facilities_ids', '');
    }

    if (!sessionStorage.getItem('distance')) {
      sessionStorage.setItem('distance', '');
    }

    

    this.state = {
      meta_title: meta.meta_title,
      meta_desc: meta.meta_desc,
      pageindex: 1,
      totalsplitpages: 0,
      totalrecords: 0,
      pgnumber: 0,
      perpage: PAGI_PERPAGE,
      centerLocation: centerLocation,
      cate_desc: '',
      sortby: '',
      similarList: [],
      pageOfItems: [],
      review: 0,
      reviews: 0,
      showcp:false,
      review_change: false,
      review_social: 0,
      showElements: false,
      distance_option: false,
      facilities_option: false,
      affilation_option: false,
      classification_option: false,
      sortby_option: true,
      review_option: false,
      reviews_option: false,
      schoolsList: [],
      filteredList: [],
      distList: [],
      facilitesList: [],
      feeList: [],
      type: [],
      fees_option: false,
      error: false,
      filters: { facilities: [], review: '' },
      distanceList: [],
      pages: [1],
      lat: localStorage.getItem("latitude") ? localStorage.getItem("latitude") : CENTERLAT,
      lng: localStorage.getItem("longitude") ? localStorage.getItem("longitude") : CENTERLNG,
      page_number: 1,
      currentpage: 1,
      //distance: DEFAULT_DIS,
      distance_change: false,
      annual_fee: DEFAULT_FEE,
      curriculam: [],
      annual_fee_change: false,
      disMax: MAXDIS_FIL,
      distance:MAXDIS_FIL,
      priceMax: MAXFEE_FIL,
      reviewList: [],
      catelist: [],
      active_cate: localStorage.getItem('school_sublink') ? localStorage.getItem('school_sublink') : 'Private School',
      //active_cate: localStorage.getItem('sub_type') ? localStorage.getItem('sub_type') : 'Private School',
      //sub_categories: this.getCategorySlug(),
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      curriculam_option: false,
      type_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down',
      type_option: false,
      categorySubTypeList: [],
      categorySubTypesList: [],
      selectedCurriculam: [],
      selected_curriculums: [],
      selectedType: [],
      selectedFacilities: [],
      selectedAffilation: [],
      selectedClassification: [],
      totalPages: 0,
      totalResults: 0,
      isloading: true,
      filter_toggle: false,
      filter_sort: false,
      curriculam_texts: [],
      type_texts: [],
      location_texts: [],
      fees_texts: [],
      ratings_texts: [],
      googleratings_texts: [],
      facilities_texts: [],
      filtered_pages: [],
      filter_sort: false,
      distance: 30,
      openModalLogin: false,
      user_id: 0,
      selectedCurOption :'All',
      schoolSEOContent:'',
      logged_auth: localStorage.getItem("logged_auth") ? localStorage.getItem("logged_auth") : false,
      current_location:(localStorage.getItem("current_location"))?localStorage.getItem("current_location"):this.props.match.params.city,
      isEschool : (this.props.match.params.subcategory=='e-schools') ? true:false,
      scat:this.props.match.params.subcategory,
      showloginreq:false,
      pagetitle: '<h1>Best Private Schools in ' +this.props.match.params.city+' :2024-25</h1>'
    };
    this.filterToogle = this.filterToogle.bind(this);
    this.getfacilities(); this.geteducation_system();
    this.getschool_type(); this.Sub_Cat_type(); this.Sub_Cat_types();

    this.storefilteredpage();
    

    this.onChangePage = this.onChangePage.bind(this);
    this.expandfilters = this.expandfilters.bind(this);
    this.handleplaceSelect = this.handleplaceSelect.bind(this);
    this.handleDistanceChange = this.handleDistanceChange.bind(this);
    this.handleAnnualfeeChange = this.handleAnnualfeeChange.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
    this.onStarClickSocial = this.onStarClickSocial.bind(this);
    this.onRemoveTagC = this.onRemoveTagC.bind(this);
    this.onRemoveTagT = this.onRemoveTagT.bind(this);
    this.onRemoveTagF = this.onRemoveTagF.bind(this);
    this.onRemoveTagR = this.onRemoveTagR.bind(this);
    this.onRemoveTagL = this.onRemoveTagL.bind(this);
    this.onRemoveTagD = this.onRemoveTagD.bind(this);
    this.onRemoveTagGR = this.onRemoveTagGR.bind(this);
    this.removeAllCache = this.removeAllCache.bind(this);
    this.storefilteredpage = this.storefilteredpage.bind(this);
    this.setSeoContent = this.setSeoContent.bind(this);
    this.handleplaceChange = this.handleplaceChange.bind(this);
    this.enquireThis = this.enquireThis.bind(this);

    this.enquireThisRegOnly = this.enquireThisRegOnly.bind(this);
    this.enquireThisPaidOnly = this.enquireThisPaidOnly.bind(this);

    this.handleCloseCp = this.handleCloseCp.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changeOption = this.changeOption.bind(this);
    this.changeSelectOption = this.changeSelectOption.bind(this);

  }



  setSeoContent(){

    let filterData = JSON.stringify({
      vertical: 'schools/'+this.props.match.params.subcategory,
      city:this.props.match.params.city  
    });


    verticalSeoContent(filterData).then((response) => {

        if(response.status==1){
          this.setState({schoolSEOContent:response.content});
        }

    });
  }

  /* $(e.target).attr('data-catid') */

  setSeoContentBkup(){

    console.log("dsfdfdf",this.props.match.params.subcategory);

    if(this.props.match.params.subcategory=='private-schools'){

        let html=`<p>Are you searching for the best private schools in `+this.props.match.params.city+` ?</p>
                  <p>Best Private Schools in `+this.props.match.params.city+` <br/>
                  Search> Choose> Compare and Select the best CBSE schools near me and Best ICSE schools near me location</p>
                  <p>Private schools are non-government, independent schools. These schools have the right to select students. Since they do not rely on government funding, they are completely dependent on the students' fees. These private schools include affiliated with the State government as well as ICSE, CBSE, or IB Board. Choose <a href="https://www.bewise.in/best-schools-near-me" target="_blank">the best schools in near me</a> Check the best private school's admission criteria, boards, syllabus, and infrastructure as per you’re your child’s needs. Search for Best CBSE schools near me or Best ICSE Schools near me through BeWise. Check out the list of <a href="https://www.bewise.in/`+this.props.match.params.city+`/schools/private-schools" target="_blank">best private schools in `+this.props.match.params.city+`</a> @BeWise.</p>`;

        this.setState({schoolSEOContent:html});

    }

    if(this.props.match.params.subcategory=='public-schools'){

        let html=`<p>Find the Best Public Schools in Bangalore&nbsp;</p>

<p>Are you looking for the best schools in near me locations?&nbsp;</p>

<p>Search&gt; Choose&gt; Compare and Select the best CBSE schools near me and Best ICSE schools near me location &nbsp;</p>

<p>A public school is a school that runs on public funds, usually government-imposed taxes. But in India, a private school is called a public school because it is for all those people who can pay. Check the best public school&#39;s admission criteria, boards, syllabus, and infrastructure as per you&rsquo;re your child&rsquo;s needs. Search for Best CBSE schools near me or Best ICSE Schools near me through BeWise. We decided to compile a list of the <a href="https://www.bewise.in/bengaluru/schools/public-schools" rel="noreferrer noopener" target="_blank">Best Public schools in Bangalore</a> near me locations that are the best school based on a variety of parameters. Select the <a href="https://www.bewise.in/best-schools-near-me" rel="noreferrer noopener" target="_blank">best school near me</a> for your child&nbsp;</p>
`;

        this.setState({schoolSEOContent:html});      
      
    }

    if(this.props.match.params.subcategory=='boarding-schools'){ 

        let html=`<p>Searching for the best boarding schools in `+this.props.match.params.city+`?</p>
                  <p>Find the best boarding school near me location <br/>
                  Search> Choose> Compare and Select the best CBSE boarding schools near me , the Best ICSE boarding schools near me location, or the Best International Boarding school</p>
                  <p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">A boarding school is </span></span><em><span style="color:#0e101a"><span style="font-family:Arial,serif">a school where children live within premises while being given formal instruction</span></span></em><span style="color:#0e101a"><span style="font-family:Arial,serif">. Boarding schools do indeed cost more than day schools, but this is only because of the added costs of residential living. Hostel rooms and services are priced separately, and food is charged separately as well. Depending on the facility you wish to add to your child, some schools charge different amounts. BeWise has put together a list of top </span></span><a href="https://www.bewise.in/bengaluru/schools/boarding-schools"><span style="font-family:Arial,serif">best residential schools in `+this.props.match.params.city+`</span></a><span style="color:#0e101a"><span style="font-family:Arial,serif"> to help you choose the right </span></span><a href="https://www.bewise.in/best-schools-near-me"><span style="font-family:Arial,serif">school near you</span></a><span style="color:#0e101a"><span style="font-family:Arial,serif"> based on the needs of your child.</span></span></span></span></p>`;

        this.setState({schoolSEOContent:html});      
      
    }

    if(this.props.match.params.subcategory=='international-schools'){

        let html=`<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span >Looking for the Best International School in `+this.props.match.params.city+`?</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span >Choose the best international School near me location with BeWise.</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span >Search&gt; Choose&gt; Compare and Select the Best International Boarding school in `+this.props.match.params.city+`</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span >An international school is&nbsp;</span></span><em><span style="color:#0e101a"><span style="font-family:Arial,serif">an institution that promotes education in an international environment or framework</span></span></em><span style="color:#0e101a"><span style="font-family:Arial,serif">. With our guide to the&nbsp;</span></span><a href="https://www.bewise.in/`+this.props.match.params.city+`/schools/international-schools"><span style="color:#4a6ee0"><span style="font-family:Arial,serif">best international schools in Bangalore</span></span></a><span style="color:#0e101a"><span style="font-family:Arial,serif">, we can help you find a school that will set your child apart from their peers. Check the best international school&#39;s admission criteria, boards, syllabus, and infrastructure as per you&rsquo;re your child&rsquo;s needs. Check out the list of best private schools in Bangalore @BeWise. We decided to compile a list of the Best international schools in Bangalore near me Choose the </span></span><a href="https://www.bewise.in/best-schools-near-me"><span style="font-family:Arial,serif">best school near me</span></a><span style="color:#0e101a"><span style="font-family:Arial,serif"> for your child.</span></span></span></span></p>
`;

        this.setState({schoolSEOContent:html});      
      
    }

    if(this.props.match.params.subcategory=='school-special-needs'){

        let html=`<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">Looking for the best special needs school in Bangalore?</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">Choose the best special need school near me location with BeWise.</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">Search&gt; Choose&gt; Compare and Select the best special need school in Bangalore.</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">The main purpose of special schools in Bangalore is to educate students with severe disabilities who otherwise have difficulty learning at a regular school. Such kind of special education should give priority, to the enjoyment of education by special children. Like other children, special children, have the right to receive the proper education that helps them to grow and enjoy themselves without fearing it. Check out the list of best special needs schools in Bangalore @BeWise. We decided to compile a list of the </span></span><a href="https://www.bewise.in/`+this.props.match.params.city+`/schools/school-special-needs"><span style="font-family:Arial,serif">Best special need school in Bangalore</span></a><span style="color:#0e101a"><span style="font-family:Arial,serif"> near me.</span></span></span></span></p>`;

        this.setState({schoolSEOContent:html});      
      
    }

    if(this.props.match.params.subcategory=='alternative-schools'){

        let html=`<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">Searching for the best Alternative schools in Bangalore?</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">Find the best Alternative/online schools in Bangalore.</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">Interested in something different than mainstream education? There is a list of Bangalore&rsquo;s best alternative schools near me in BeWise</span></span></span></span></p>

<p><span ><span style="font-size:medium"><span style="color:#0e101a"><span style="font-family:Arial,serif">An alternative school is&nbsp;</span></span><em><span style="color:#0e101a"><span style="font-family:Arial,serif">an educational establishment with a curriculum and methods that are non-traditional</span></span></em><span style="color:#0e101a"><span style="font-family:Arial,serif">. Alternative schooling is different from mainstream schooling in many ways. Alternative schools have more educational and developmental objectives than conventional schools. They often have curriculum elements that focus on improving student self-esteem, fostering the growth of individuality, and enhancing social skills. So, Check out the list of </span></span><a href="https://www.bewise.in/`+this.props.match.params.city+`/schools/alternative-schools"><span style="font-family:Arial,serif">best Alternative schools near me</span></a><span style="color:#0e101a"><span style="font-family:Arial,serif"> location.</span></span></span></span></p>`;

        this.setState({schoolSEOContent:html});    
      
    }
  }

  storefilteredpage() {

    let thispage = window.location.pathname;

    var filteredPages = this.state.filtered_pages;
    filteredPages.push(thispage);
    sessionStorage.setItem("filtered_pages", filteredPages);

    let curriculam_ids = sessionStorage.getItem('curriculam_ids').split(',');

    this.setState({ curriculam: curriculam_ids });

  }

  updateStyleOfFee() {
    const allRanges = document.querySelectorAll(".range-wrap");

    allRanges.forEach(wrap => {
      const range = wrap.querySelector(".slider");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
    });

    function setBubble(range, bubble) {
      const val = range.value;
      console.log('setBubble', val)
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }
  }

  handleDistanceChange = (e) => {

    let distance = e.target.value;
    this.setState({
      distance: e.target.value,
    });
    sessionStorage.setItem('distance', distance);

    this.updateStyleOfFee();
    this.handleFilterChangeV1(distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  handleAnnualfeeChange = (e) => {
    let fees_texts = [];
    let annual_fee = e.target.value;
    fees_texts.push(annual_fee);
    this.setState({
      annual_fee: e.target.value, fees_texts: fees_texts
    });
    sessionStorage.setItem('fees_texts', fees_texts.toString());

    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  onStarClickSocial = (e) => {
    let googleratings_texts = [];
    let probName = e.target.name;
    const filterValue = e.target.value;
    googleratings_texts.push(filterValue);

    sessionStorage.setItem('googleratings_texts', googleratings_texts.toString());

    this.setState({ [probName]: filterValue, googleratings_texts: googleratings_texts });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, filterValue);
  }



  handleRatingChange = (e) => {
    let ratings_texts = [];
    let review = e.target.value;
    ratings_texts.push(review);
    this.setState({
      review: e.target.value, ratings_texts: ratings_texts
    });

    sessionStorage.setItem('ratings_texts', ratings_texts.toString());

    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }


  handleFacilitiesChange = (e) => {
    let facilities;
    var facilities_texts = []
    var checkboxes = document.querySelectorAll('input[name="facilities"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });
    facilities = values;

    Array.prototype.forEach.call(checkboxes, function (el) {
      facilities_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('facilities_texts', facilities_texts.toString());
    sessionStorage.setItem('facilities_ids', values.toString());

    this.setState({
      facilities: values,
      facilities_texts: facilities_texts,
      selectedFacilities: values
    });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  handleAffilationCheckbox = (e) => {
    let affilation;
    var checkboxes = document.querySelectorAll('input[name="affilation"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });


    affilation = values;
    this.setState({
      affilation: values,
      selectedAffilation: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  handleClassCheckbox = (e) => {
    let classification;
    var checkboxes = document.querySelectorAll('input[name="classification"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });
    classification = values;
    this.setState({
      classification: values,
      selectedClassification: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  handleCurriculamCheckbox = (e) => {
    let curriculam;

    var checkboxes = document.querySelectorAll('input[name="curriculam"]:checked'), values = [];
    var curriculam_texts = []
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });

    Array.prototype.forEach.call(checkboxes, function (el) {
      curriculam_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('curriculam_texts', curriculam_texts.toString());
    sessionStorage.setItem('curriculam_ids', values.toString());
    //console.log(curriculam_texts);
    curriculam = values;
    this.setState({
      curriculam: values,
      curriculam_texts: curriculam_texts,
      selectedCurriculam: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  handleTypeCheckbox = (e) => {
    let type;

    var type_texts = []

    var checkboxes = document.querySelectorAll('input[name="type"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });


    Array.prototype.forEach.call(checkboxes, function (el) {
      type_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('type_texts', type_texts.toString());
    sessionStorage.setItem('type_ids', values.toString());
    type = values;
    this.setState({
      type: values,
      type_texts: type_texts,
      selectedType: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, type, this.state.sortby, this.state.sort_order, this.state.review_social);
  }

  clearSort = () => {
    let sortby = '';
    let sort_order = '';

    this.setState({
      sortby: '',
      sort_order: '',
      sortby_option: true
    });
    this.updateStyleOfFee();

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, sortby, sort_order, this.state.review_social, 1);

  }
  handle_sortby_list = (e, val) => {
    let sortby = e ? e.target.value : val;
    let sort_order = 1;

    this.setState({
      sortby: sortby,
      sort_order: 1,
      sortby_option: true
    });
    this.updateStyleOfFee();

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, sortby, sort_order, this.state.review_social, 1);

  }
  handlePerPage = (e) => {
    let perpage = e.target.value;
    this.setState({ perpage })

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social, 1, '', '', '', perpage);

  }

  handle_Sortby = (e) => {

    this.setState((prevState) => ({
      sortby_option: !prevState.sortby_option,
    }));

    this.handle_SortIcon();

  };


  handle_SortIcon() {
    let sort_order = 1;
    if (this.state.sortby_option == true) {
      sort_order = 2;
    } else if (this.state.sortby_option == false) {
      sort_order = 1;
    }
    this.setState({
      sort_order: sort_order
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, sort_order, this.state.review_social, 1);
  }


  handleFilterChangeV1(distance, annual_fee, review, facilities, affilation, classification, sub_categories, curriculam, type, sortby, sort_order, review_social, page_number = 1, operators = '', lat = '', lng = '', perpage) {
    perpage = perpage ? perpage : this.state.perpage;
    let temppgnum = (this.state.pgnumber == 0) ? 0 : this.state.pgnumber;
    
    this.setState({isloading:true});
    
    if (operators == '+') {

      temppgnum = parseInt(temppgnum) + perpage;
      this.setState({
        pgnumber: temppgnum,
        pageindex: this.state.pageindex + 1
      });

    } else if (operators == '-') {

      temppgnum = parseInt(temppgnum) - perpage;
      this.setState({
        pgnumber: temppgnum,
        pageindex: this.state.pageindex - 1
      });
    }


    let filterData = JSON.stringify({
      current_latitude: lat ? lat : this.state.lat,
      current_longitude: lng ? lng : this.state.lng,
      location:this.state.current_location,
      distance: distance ? distance : 30,
      annual_fee: annual_fee,
      review: review,
      facilities: facilities,
      affilation: affilation,
      classification: classification,
      sub_categories: this.state.sub_categories,
      curriculam: curriculam,
      type: type,
      sortby: sortby,
      sort_order: sort_order,
      review_social: review_social,
      offset: parseInt(temppgnum),
      sub_category_keyword: this.state.active_cate,
      perpage: perpage,
      vertical: 'schools'
    });


    verticalTotalCount(filterData).then((response) => {

      this.setState({
        totalrecords: response.data
      });

      let divided = Math.ceil(response.data / perpage);

      this.setState({
        totalsplitpages: divided
      });


    });

    verticalListing(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list);
      } else if (response.status == 0) {
        this.setState({
          totalPages: 0,
          isloading: false
        });
      }
    });

  }

  handleFilterChange(distance, annual_fee, review, facilities, affilation, classification, sub_categories, curriculam, type, sortby, sort_order, review_social, page_number = 1, lat = '', lng = '') {

    let filterData = JSON.stringify({
      current_latitude: lat ? lat : this.state.lat,
      current_longitude: lng ? lng : this.state.lng,
      distance: distance,
      annual_fee: annual_fee,
      review: review,
      facilities: facilities,
      affilation: affilation,
      classification: classification,
      sub_categories: this.state.sub_categories,
      curriculam: curriculam,
      type: type,
      sortby: sortby,
      sort_order: sort_order,
      review_social: review_social,
      page_number: page_number ? page_number : this.state.page_number,
      perpage: this.state.perpage
    });

    schoolSecondFilter(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list, page_number);
      } else if (response.status == 0) {
        this.setState({
          filteredList: [],
          pageOfItems: [],
          totalPages: 0,
          isloading: false
        });
      }
    });

  }
  componentDidUpdate() {
    // let current = window.jQuery(".page-item.page-number.active").find('a').html();
    // if ((current) && this.state.currentpage != current) {
    //   this.setState({
    //     currentpage: current
    //   })
    // }

    var cards = $(".premiumuser");
    for(var i = 0; i < cards.length; i++){
      var target = Math.floor(Math.random() * cards.length -1) + 1;
      var target2 = Math.floor(Math.random() * cards.length -1) +1;
      cards.eq(target).before(cards.eq(target2));
    }


  }


  changeSelectOption = (e) => {

    this.setState({
      selectedCurOption:  e.target.value
    });


    let curriculam;
    let values = [];
    var curriculam_texts = []

    if(e.target.value!='All'){
      values.push(e.target.value);
    }else{
      const checkbox = document.getElementById('checkbox-${attrival}');
      checkbox.checked = true;
      values = [];
    }
    curriculam_texts.push(e.target.value);
    sessionStorage.setItem('curriculam_texts', curriculam_texts.toString());
    sessionStorage.setItem('curriculam_ids', values.toString());
    this.setState({ curriculam: attrival });
    //console.log(curriculam_texts);
    curriculam = values;
    console.log(values);
    this.setState({
      curriculam: values,
      curriculam_texts: curriculam_texts,
      selectedCurriculam: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
 

  }

  changeOption = (e) => {
    
    var attrival = $(e.target).attr("data-id");
    var attrivalTxt = $(e.target).attr("data-text");
    console.log(attrival);

    this.setState({
      selectedCurOption: attrival
    });
  
    let curriculam;
    let values = [];
    var curriculam_texts = []

    if(attrival!='All'){
      values.push(attrival);
    }else{
      const checkbox = document.getElementById('checkbox-${attrival}');
      checkbox.checked = true;
      values = [];
    }
    curriculam_texts.push(attrivalTxt);
    sessionStorage.setItem('curriculam_texts', curriculam_texts.toString());
    sessionStorage.setItem('curriculam_ids', values.toString());
    this.setState({ curriculam: attrival });
    //console.log(curriculam_texts);
    curriculam = values;
    console.log(values);
    this.setState({
      curriculam: values,
      curriculam_texts: curriculam_texts,
      selectedCurriculam: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
 
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };  

  handleSubmitEnquiry = (e) => {

    e.preventDefault();

    let reviewData = JSON.stringify({
      to_email: this.state.email_id,
      user_name: this.state.first_name+" "+this.state.last_name,
      vendor_id : this.state.id,
      vendor_name: this.state.schoolName,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      vertical: "schools",
      location:this.state.current_location,
      any_message: this.state.any_message,
      reg_email:this.state.reg_email,
      reg_mobile:this.state.reg_mobile,
      userType:this.state.userType,
      lead:"enquiry"
    });
    

    saveEnqLead(reviewData).then((response) => {
      if (response.status == 1) {
        
        this.setState({ showcp: false });

        let toastr = '';
          toastr = window.toastr.success; //warning
          toastr('Thank you!, message is successfully sent', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"  
        });


      }
    });
 
  };

  componentDidMount() {
    //this.getCategorySlug();
    // localStorage.setItem('school_sublink', '');
    // localStorage.setItem('school_sublink_id', '');
 


    this.setState({
      city: this.props.match.params.city,
      subcategory: this.props.match.params.subcategory
    });

    var var_metatitle = "BeWise";
    var var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Private Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    if (this.props.match.params.subcategory == 'private-schools') {
      var_metatitle = "Private Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Private Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'public-schools') {
      var_metatitle = "Public Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Public Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'board-schools') {
      var_metatitle = "Boarding Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Boarding Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'boarding-schools') {
      var_metatitle = "Boarding Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Boarding Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'international-schools') {
      var_metatitle = "International Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about International Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'special-needs') {
      var_metatitle = "Special Needs Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Special Needs for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'alternative-schools') {
      var_metatitle = "Alternative Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Alternative Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'open-schools') {
      var_metatitle = "Open Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about Open Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory == 'e-schools') {
      var_metatitle = "E-Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare - fees, facilities, reviews, ratings and other key information about E-Schools for your child near you at BeWise, a fun and learning experience to help your child learn and grow';
    }


    this.setState({ metatitle: var_metatitle, metadesc: var_metadesc });

    let thispage = window.location.pathname;
    let filtered_pages = sessionStorage.getItem('filtered_pages');

    this.getSchoolList();
    this.setSeoContent();
    this.getPreSchoolCateList();
    var This = this;
    navigator.geolocation.getCurrentPosition(function (position) {
      This.get_current_loaction(position.coords.latitude, position.coords.longitude);
    },
      function (error) {
        console.error("Error Code = ", error);
      });
    this.updateStyleOfFee();

    let data_auth = (localStorage.getItem("myData"));
    let userid;
    if (data_auth) {
      let auth_data = JSON.parse(data_auth)
      this.setState({
        user_id: auth_data.user_id,
      });
    }



  }
  async getfacilities() {
    let response = await FetchCall.getSchoolListDatas('facilities');
    if (response) {
      this.setState({ facilitesList: response.results });
    }
  }

  async getschool_type() {
    let response = await FetchCall.getSchoolListDatas('school_type');
    if (response) {
      this.setState({ schooltypeList: response.results });
    }
  }

  async geteducation_system() {
    let response = await FetchCall.getSchoolListDatas('education_system');
    if (response) {
      this.setState({ classificationList: response.results });
    }
  }

  async Sub_Cat_type() {
    let response = await FetchCall.getSchoolListDatas('curriculum');
    if (response.status == 1) {
      this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
    } else {
      this.setState({ cat_type: false });
    }
  }

  handleCloseCp(){
    this.setState({showcp:false});
  }


  enquireThisRegOnly  = (e) => {

    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
      let name = $(e.target).attr('data-name');
      let id = $(e.target).attr('data-id');
      this.setState({showcp:true, userType:"registeredonly", schoolName:name, id:id});
    }
    else{

      let toastr = '';
      toastr = window.toastr.warning; //warning
      toastr('Sign up with us to enable this feature', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });

    }
  } 
  
  enquireThisPaidOnly  = (e) => {

    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
      let name = $(e.target).attr('data-name');
      let id = $(e.target).attr('data-id');
      this.setState({showcp:true, userType:"paidalso", schoolName:name, id:id});
    }
    else{
      let toastr = '';
      toastr = window.toastr.warning; //warning
      toastr('Sign up with us to enable this feature', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
    }

  }

  enquireThis = (e) => {

    let name = $(e.target).attr('data-name');
    let id = $(e.target).attr('data-id');
    this.setState({showcp:true, schoolName:name, id:id});
  }

  async Sub_Cat_types() {
    let response = await FetchCall.getSchoolListDatas('type');
    if (response.status == 1) {
      this.setState({ categorySubTypesList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
    } else {
      this.setState({ cat_type: false });
    }
  }


  handle_Distance = (e) => {
    if (this.state.distance_option === false) {
      this.setState({
        dis_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        dis_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      distance_option: !prevState.distance_option,
    }));
    this.setState({
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_option: false,
      affilation_option: false,
      classification_option: false,
      curriculam_option: false,
      type_option: false,
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();

  };


  handle_Facilities = (e) => {
    if (this.state.facilities_option === false) {
      this.setState({
        fac_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        fac_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      facilities_option: !prevState.facilities_option,
    }));
    this.setState({
      distance_option: false,
      fees_option: false,
      review_option: false,
      reviews_option: false,
      affilation_option: false,
      classification_option: false,
      curriculam_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };
  handle_Fees = (e) => {
    if (this.state.fees_option === false) {
      this.setState({
        fee_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        fee_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      fees_option: !prevState.fees_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      review_option: false,
      reviews_option: false,
      affilation_option: false,
      classification_option: false,
      curriculam_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Review = (e) => {
    if (this.state.review_option === false) {
      this.setState({
        review_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        review_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      review_option: !prevState.review_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      reviews_option: false,
      affilation_option: false,
      classification_option: false,
      curriculam_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Reviews = (e) => {
    if (this.state.reviews_option === false) {
      this.setState({
        reviews_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        reviews_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      reviews_option: !prevState.reviews_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      affilation_option: false,
      classification_option: false,
      curriculam_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Affilation = (e) => {
    if (this.state.affilation_option === false) {
      this.setState({
        affilation_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        affilation_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      affilation_option: !prevState.affilation_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_option: false,
      classification_option: false,
      curriculam_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Classification = (e) => {
    if (this.state.classification_option === false) {
      this.setState({
        classification_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        classification_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      classification_option: !prevState.classification_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_option: false,
      affilation_option: false,
      curriculam_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Curriculam = (e) => {
    if (this.state.curriculam_option === false) {
      this.setState({
        curriculam_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        curriculam_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      curriculam_option: !prevState.curriculam_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_option: false,
      affilation_option: false,
      classification_option: false,
      type_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      type_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Type = (e) => {
    if (this.state.type_option === false) {
      this.setState({
        type_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        type_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      type_option: !prevState.type_option,
    }));


    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_option: false,
      affilation_option: false,
      classification_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      affilation_arrow: 'fa-angle-down',
      classification_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down',
    });
    this.updateStyleOfFee();
  };

  handle_clearFilter = (e) => {
    window.location.reload();
  }

  handleplaceChange = address => {
    /*
    console.log('address', address)
    let location_texts=[];
    location_texts.push(address);
    this.setState({location_texts:location_texts});

    sessionStorage.setItem('location_texts', location_texts.toString());
    */
    this.setState({ address, pin_code: '', state: '', location: '' });
    if (address==''){
      this.clearFilter();
      /*
      this.setState({ lat: localStorage.getItem('latitude'), lng:localStorage.getItem('longitude')});
      this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities,
        this.state.affilation, this.state.classification, this.state.sub_categories,
        this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order,
        this.state.review_social, this.state.page_number);
      */  
    }
  };

  handleplaceSelect = address => {

    this.setState({ address: address, location_texts: address });

    sessionStorage.setItem('location_texts', address);
    console.log('address selected', address);
    // this.Geocode_location();

    Geocode.fromAddress(address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
            city = response.results[0].address_components[i].long_name;
          }

        }

        this.setState({ lat: response.results[0].geometry.location.lat, lng: response.results[0].geometry.location.lng });

        this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities,
          this.state.affilation, this.state.classification, this.state.sub_categories,
          this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order,
          this.state.review_social, this.state.page_number);

      },
      error => {
        console.error(error);
      }
    );
  };

  getPreSchoolCateList = async () => {
    let catData = JSON.stringify({
      id: 1,
    });
    console.log('**list', catData)
    catgoryList(catData).then((response) => {
      if (response.status == 1) {
        const list = response.data;
        // console.log('**list',list)
        this.setState({
          catelist: list,
        });
      } else {

      }
    });
  };

  getSchoolList = async () => {


    let SlugName = JSON.stringify({
      category_slug: this.props.match.params.subcategory
    });

    getSchoolCategoryIdBySlug(SlugName).then((response) => {
      if (response.status == 1) {
        this.setState({
          sub_categories: response.subcategory_id,
          active_cate: response.category_name,
          cate_desc: response.descrp,
        });

        /*
        let filterData = JSON.stringify({
          current_latitude: this.state.lat,
          current_longitude: this.state.lng,
          location: this.state.location,
          distance: this.state.distance,
          annual_fee: this.state.annual_fee,
          review: 0,
          facilities: this.state.facilities,
          sub_categories: response.subcategory_id,
          review_social: 0,
          page_number: this.state.page_number,
          perpage: PAGI_PERPAGE

        });

        schoolSecondFilter(filterData).then((response) => {
          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              filteredList: [],
              pageOfItems: [],
              totalPages: 0,
              isloading: false
            });
          }
        });
        */
        let thispage = window.location.pathname;

         
          let curriculam_ids = sessionStorage.getItem('curriculam_ids').split(',');
          let type_ids = sessionStorage.getItem('type_ids').split(',');
          let fees_texts = sessionStorage.getItem('fees_texts');
          let distance = sessionStorage.getItem('distance');
          let current_lats = sessionStorage.getItem('current_lats');
          let current_lngs = sessionStorage.getItem('current_lngs');
        

        let filterData = JSON.stringify({
          current_latitude: (current_lats != '' && current_lats != null) ? current_lats : this.state.lat,
          current_longitude: (current_lngs != '' && current_lngs != null) ? current_lngs : this.state.lng,
          location: this.state.current_location,
          distance: (distance != '' && distance != null) ? distance : this.state.distance,
          curriculam: (curriculam_ids != '' && curriculam_ids != null) ? curriculam_ids : this.state.curriculam,
          type: (type_ids != '' && type_ids != null) ? type_ids : this.state.type,
          annual_fee: (fees_texts != '' && fees_texts != null) ? fees_texts : this.state.annual_fee,
          review: 0,
          facilities: this.state.facilities,
          sub_categories: response.subcategory_id,
          sub_category_keyword: this.state.active_cate,
          review_social: 0,
          offset: 0,
          perpage: this.state.perpage,
          vertical: 'schools'
        });

        verticalTotalCount(filterData).then((response) => {

          this.setState({
            totalrecords: response.data
          });

          let divided = Math.ceil(response.data / this.state.perpage);

          this.setState({
            totalsplitpages: divided
          });


        });


        verticalListing(filterData).then((response) => {
          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              filteredList: [],
              pageOfItems: [],
              totalPages: 0,
              isloading: false
            });
          }
        });

        //console.log("Dfdfdffsdxsddsd");
      }
    });
  };
  setPage(list, page_number = '') {
    let data = list.data;
    let total_pages = list.total_pages;
    this.setState({
      filteredList: data,
      pageOfItems: data,
      totalPages: total_pages,
      currentpage: page_number != '' ? page_number : 1,
      page_number: page_number != '' ? page_number : 1,
      totalResults: list.length,
      isloading: false
    });
  }
  get_current_loaction(latitude, longitude) {
    this.setState({
      current_latitude: latitude,
      current_longitude: longitude,
    });
  }



  showElement = () => {
    this.setState({
      showElements: !this.state.showElements,
    })
  }


  onChangePrevPage = (page_number) => {
    this.setState({
      pgnumber: page_number,
      currentpage: page_number
    })
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social, page_number, '-');
    window.scrollTo(0, 0);
  }

  onChangeNextPage = (page_number) => {
    this.setState({
      pgnumber: page_number,
      currentpage: page_number
    })
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social, page_number, '+');
    window.scrollTo(0, 0);
  }

  expandfilters = (e) => {

    var elms = document.getElementsByClassName("filtersection");

    Array.from(elms).forEach((x) => {
      if (x.style.display === "none") {
        $(".collapsiblesection").html("-");
        x.style.display = "block";
      } else {
        $(".collapsiblesection").html("+");
        x.style.display = "none";
      }
    })

  }

  clearFilter = () =>{
      this.setState({
          lng:localStorage.getItem('longitude'),
          lat:localStorage.getItem('latitude'),
          address:'',
          disMax:MAXDIS_FIL,
          distance:MAXDIS_FIL
      });
      sessionStorage.setItem('distance', MAXDIS_FIL);

      this.getSchoolList();
  }

  removeAllCache = () => {

    sessionStorage.setItem('curriculam_texts', '');
    sessionStorage.setItem('curriculam_ids', '');

    sessionStorage.setItem('type_texts', '');

    sessionStorage.setItem('type_ids', '');

    sessionStorage.setItem('location_texts', '');

    sessionStorage.setItem('fees_texts', '');
    sessionStorage.setItem('distance', '');
    sessionStorage.setItem('ratings_texts', '');

    sessionStorage.setItem('googleratings_texts', '');

    sessionStorage.setItem('facilities_texts', '');
    sessionStorage.setItem('facilities_ids', '');


    var x = document.getElementsByName('curriculam');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    var x = document.getElementsByName('type');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }


    var x = document.getElementsByName('facilities');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    const allRanges = document.querySelectorAll(".range-wrap");

    allRanges.forEach(wrap => {
      const range = wrap.querySelector(".slider");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
      range.value = 0;
    });

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    //this.setState({review:0,review_social:0, distance:0, annual_fee:0});

    this.getSchoolList();

  };

  /*
  myRangeReview
myRangeSocialRating
myRangeDistance
myRangeAnnualFee
annual_fee
review
review_social
distance
*/




  removeAnnulaFees = (idx, item, e) => {

    const reviewRange = document.querySelector("#myRangeAnnualFee");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);
    range.value = 0;

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ review: 0 });

  };

  onRemoveTagC = (idx, item, e) => {

    let curriculamdata = sessionStorage.getItem('curriculam_texts').split(',');
    curriculamdata.splice(idx, 1);
    sessionStorage.setItem('curriculam_texts', curriculamdata.toString());
    let c = this.state.curriculam;
    c.splice(idx, 1);
    this.setState({
      curriculam: c
    });

    let curriculam_ids = sessionStorage.getItem('curriculam_ids').split(',');
    curriculam_ids.splice(idx, 1);
    sessionStorage.setItem('curriculam_ids', curriculam_ids.toString());

    let s = this.state.selectedCurriculam;
    s.splice(idx, 1);
    this.setState({
      selectedCurriculam: s
    });

    this.unCheck('curriculam', idx);

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  };

  unCheck = (classname, index) => {

    var x = document.getElementsByName(classname);
    for (var i = 0; i <= x.length; i++) {
      if (index == i) {
        x[i].checked = false;
      }
    }
  }

  onRemoveTagT = (idx, item, e) => {
    let typedata = sessionStorage.getItem('type_texts').split(',');
    typedata.splice(idx, 1);
    sessionStorage.setItem('type_texts', typedata.toString());

    let type_ids = sessionStorage.getItem('type_ids').split(',');
    type_ids.splice(idx, 1);
    sessionStorage.setItem('type_ids', type_ids.toString());

    let c = this.state.type;
    c.splice(idx, 1);
    this.setState({
      type: c
    });

    this.unCheck('type', idx);
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);
  };

  onRemoveTagD = (item, e) => {

    let distancedata = sessionStorage.getItem('distance');

    sessionStorage.setItem('distance', '');

    const reviewRange = document.getElementById("myRangeDistanceWrap");
    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {

      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(100% + (0px))`;
    }

    let distance = 30;
    this.setState({ distance: distance });

    this.handleFilterChangeV1(distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);

  };

  onRemoveTagL = (item, e) => {

    let locationdata = sessionStorage.getItem('location_texts');

    sessionStorage.setItem('location_texts', '');

    const reviewRange = document.getElementById("myRangeDistanceWrap");
    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {

      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ address: '' });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);

  };

  onRemoveTagFees = (idx, item, e) => {
    let feesdata = sessionStorage.getItem('fees_texts').split(',');
    feesdata.splice(idx, 1);
    sessionStorage.setItem('fees_texts', feesdata.toString());

    const reviewRange = document.querySelector("#myRangeAnnualFeeWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ annual_fee: DEFAULT_FEE });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);

  };

  onRemoveTagR = (idx, item, e) => {
    let ratingsdata = sessionStorage.getItem('ratings_texts').split(',');
    ratingsdata.splice(idx, 1);

    const reviewRange = document.getElementById("myRangeReviewWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.value = 0;
    const val = 0;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;
    // Sorta magic numbers based on size of the native UI thumb
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;

    this.setState({ review: 0 });

    sessionStorage.setItem('ratings_texts', ratingsdata.toString());
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);

  };

  onRemoveTagGR = (idx, item, e) => {
    let googleratingsdata = sessionStorage.getItem('googleratings_texts').split(',');
    googleratingsdata.splice(idx, 1);

    const reviewRange = document.querySelector("#myRangeSocialRatingWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);
    range.value = 0;

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ review_social: 0 });

    sessionStorage.setItem('googleratings_texts', googleratingsdata.toString());
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);

  };


  onRemoveTagF = (idx, item, e) => {
    let facilitiesdata = sessionStorage.getItem('facilities_texts').split(',');
    facilitiesdata.splice(idx, 1);

    let facilities_ids = sessionStorage.getItem('facilities_ids').split(',');
    facilities_ids.splice(idx, 1);
    sessionStorage.setItem('facilities_ids', facilities_ids.toString());

    sessionStorage.setItem('facilities_texts', facilitiesdata.toString());
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social);

  };



  onChangePage = (page_number) => {
    this.setState({
      page_number: page_number,
      currentpage: page_number
    })
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, this.state.sub_categories, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social, page_number);
  }

  homeLink = () => {
    window.location.replace('/');
  }
  subLink = () => {
    window.location.replace('/schoollinks');
  }

  breadLinkHome = () => {
    window.location.replace('/' + this.state.city + '/' + 'schools' + '/' + 'private-schools');
  }

  sub_cate() {
    localStorage.setItem('sub_type', this.state.active_cate);
    localStorage.setItem('school_sublink', this.state.active_cate);
    localStorage.setItem('school_sublink_id', this.state.sub_categories);
    localStorage.setItem('primary_search_path', window.location.href);
  }

  handleSubCategory = (subcategoryname) => {
    window.location.replace('/' + this.state.city + '/schools/' + subcategoryname);
  }

  handleCategory(name, id) {
    // this.Sub_Cat_type(id);
    console.log('active_cate', name, id);
    this.setState({
      active_cate: name,
      sub_categories: id,
    }, () => {

      console.log('active_cate', this.state.sub_categories);
      this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.facilities, this.state.affilation, this.state.classification, id, this.state.curriculam, this.state.type, this.state.sortby, this.state.sort_order, this.state.review_social, 1);

    });

  }
  filterToogle = () => {
    this.setState({
      filter_toggle: !this.state.filter_toggle,
      filter_sort: false
    });
  }
  sortToogle = () => {
    this.setState({
      filter_sort: !this.state.filter_sort,
      filter_toggle: false
    });
  }

  render() {
    const { schoolsList } = this.state;
    let topTrending = {
      category_id: 1,
      city: this.props.match.params.city,
      subcategory_term: this.props.match.params.subcategory,
      category_name: 'schools',
      sub_category: 0
    }

    let filteredData = [];
    //console.log("sdfsd", this.state.curriculam_texts);
    let curriculamdata = sessionStorage.getItem('curriculam_texts').split(',');
    if (sessionStorage.getItem('curriculam_texts') != '')
      filteredData.push('curriculum');

    let typedata = sessionStorage.getItem('type_texts').split(',');
    if (sessionStorage.getItem('type_texts') != '')
      filteredData.push('type');

    let locationdata = sessionStorage.getItem('location_texts');
    if (sessionStorage.getItem('location_texts') != '')
      filteredData.push('location');

    let distancedata = sessionStorage.getItem('distance') ? sessionStorage.getItem('distance') : '';
    if (distancedata != '')
      filteredData.push('distance');

    console.log('distancedata', filteredData);
    let feesdata = sessionStorage.getItem('fees_texts').split(',');
    if (sessionStorage.getItem('fees_texts') != '')
      filteredData.push('fees');

    let ratingsdata = sessionStorage.getItem('ratings_texts').split(',');
    if (sessionStorage.getItem('ratings_texts') != '')
      filteredData.push('ratings');

    let googleratingsdata = sessionStorage.getItem('googleratings_texts').split(',');
    if (sessionStorage.getItem('googleratings_texts') != '')
      filteredData.push('googleratings');

    let facilitiesdata = sessionStorage.getItem('facilities_texts').split(',');
    if (sessionStorage.getItem('facilities_texts') != '')
      filteredData.push('facilities');
    /*
    let curriculamdata = this.state.curriculam_texts;
    let typedata = this.state.type_texts;
    let locationdata = this.state.location_texts;
    let feesdata = this.state.fees_texts;
    let ratingsdata = this.state.ratings_texts;
    let googleratingsdata = this.state.googleratings_texts;
    let facilitiesdata = this.state.facilities_texts;
    let filteredData = ['curriculum','type'];
    */
    //console.log("fff",filteredData.length)

    let pageinfo = {
      fromvertical: 'school',
      parent:'School'
    }

    let page = {
      page: 'school',
    }

    const menuData = {
      category: 'Schools',
      category_link: `/${this.state.city}/schools/private-schools`,
      subcategory_one: this.state.active_cate,
      subcategory_one_link: '',
      subcategory_one_desc: this.state.cate_desc,
      active_main: 'schools',
      active_menu: this.props.match.params.subcategory
    }

    const subcat = this.state.active_cate;

    const pagetitle = (this.props.match.params.subcategory=='school-special-needs')? '<h1>Best '+this.state.active_cate+' schools in ' +this.props.match.params.city+' : 2024-25</h1>':'<h1>Best '+this.state.active_cate+'s  in ' +this.props.match.params.city+' : 2024-25</h1>';

    const { selectedCurOption} = this.state;

    let keywords_seo = '';
  
    
    if(this.props.match.params.subcategory=='private-schools'){
    keywords_seo = 'Best Private Schools in ' +this.props.match.params.city+' , Top CBSE Schools in ' +this.props.match.params.city+', Best CBSE/ICSE Schools near me';
    }
    if(this.props.match.params.subcategory=='public-schools'){
    keywords_seo = 'Best Public Schools in ' +this.props.match.params.city+', Top Public Schools in ' +this.props.match.params.city+', Best Public Schools near me';
    }  
    if(this.props.match.params.subcategory=='boarding-schools'){
    keywords_seo = 'Best Boarding Schools in ' +this.props.match.params.city+', Best Reasedential Schools in ' +this.props.match.params.city+', Best Boarding Schools near me';
    }
    if(this.props.match.params.subcategory=='international-schools'){
    keywords_seo = 'Best International Schools ' +this.props.match.params.city+',Top International Schools ' +this.props.match.params.city+', Best International Schools Near Me';
    }
    if(this.props.match.params.subcategory=='school-special-needs'){
    keywords_seo = 'Best Special Needs schools ' +this.props.match.params.city+', Top Special Needs schools ' +this.props.match.params.city+', Best Special Needs schools Near Me';
    }
    if(this.props.match.params.subcategory=='alternative-schools'){
    keywords_seo = 'Best Alternative Schools ' +this.props.match.params.city+', Top  Alternative Schools in ' +this.props.match.params.city+', Best Alternative Schools Near Me';
    }
    if(this.props.match.params.subcategory=='open-schools'){
    keywords_seo = 'Best Open Schools in ' +this.props.match.params.city+', Top Open Schools in ' +this.props.match.params.city+', Best Open Schools Near Me';
    }
    if(this.props.match.params.subcategory=='e-schools'){
    keywords_seo = 'Best E-Schools ' +this.props.match.params.city+', Top E-Schools in ' +this.props.match.params.city+', E-Schools Near Me';
    }

    return (
      <React.Fragment>
        { /* this.state.isloading === true &&
          (
            <React.Fragment>
              <div class="overlay-custom"></div>
              <div class='spinner' role='status'>
                <span class='sr-only'>Loading...</span>
              </div>                 
            </React.Fragment>
        ) */ }
        <Helmet>
          <title>{this.state.meta_title}</title>
          <meta name="keywords" content={keywords_seo}></meta>
        </Helmet>
        <Header menu_data={menuData} login={this.state.openModalLogin} onMobileFilterCall={this.filterToogle} onMobileSortCall={this.sortToogle} />
        <span id='Popover-mobile-filter'></span>
        <span id='Popover-mobile-sort'></span>
        <Popover className='filter-pop-over' hideArrow={true}
          placement="bottom" isOpen={this.state.filter_toggle} target="Popover-mobile-filter">
          <PopoverHeader>Sharpen your search <span class='popupclose' onClick={this.filterToogle}>close</span></PopoverHeader>
          <PopoverBody>
            {this.filterFunction(1)}
          </PopoverBody>
        </Popover>
        <Popover className='filter-pop-over' hideArrow={true}
          placement="bottom" isOpen={this.state.filter_sort} target="Popover-mobile-sort">
          <PopoverHeader>
            Sort
            <span class='popupclose' onClick={this.sortToogle}>close</span>
          </PopoverHeader>
          <PopoverBody>
            <div className='container'>
              {this.state.sortby && (
                <div className='row scrollmenu new-sort-option'>
                  <div className='col-12'>
                    <a
                      className={this.state.sortby_option ? 'filter-menu active' : 'filter-menu'}
                      href='javascript:;' onClick={this.handle_Sortby} >
                      Ascending
                    </a>
                    &nbsp;|&nbsp;
                    <a className={!this.state.sortby_option ? 'filter-menu active' : 'filter-menu'}
                      href='javascript:;' onClick={this.handle_Sortby}>
                      Descending
                    </a>
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='col-12'>
                  <ul className='pop-sort'>
                    <li
                      onClick={() => this.handle_sortby_list(null, '')}
                      className={this.state.sortby == '' && 'active'}>Default Sort </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 1)}
                      className={this.state.sortby == 1 && 'active'}>Name </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 2)}
                      className={this.state.sortby == 2 && 'active'}>Location </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 3)}
                      className={this.state.sortby == 3 && 'active'}>Rating</li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 4)}
                      className={this.state.sortby == 4 && 'active'}>Fees</li>
                  </ul>
                </div>
              </div>
            </div>
          </PopoverBody>
        </Popover>
        <section class="secound-landing features-area nav nav-tabs links-page new-landing-page" id="nav-tab" role="tablist">
          <div className='container'>
            <div class="row" style={{ padding: 10 }}>
              {filteredData.length > 0 && (
                <div className="col-12 d-block d-md-none">
                  <div className='row new-sort mob-sort-sec ml-0'>
                    <div className={'col-12 text-right'}>
                      {filteredData.length > 0 && (
                        <span class="clearallfilters" onClick={e => this.removeAllCache()}>Clear All</span>
                      )}
                    </div>
                    <div className='col-md-12 pl-2 pr-2'>
                      <div class="filterations">
                        <div class="filtersection">

                          <ul class="tagblock">
                            {filteredData.includes("curriculum") && (
                              <li class="tags">Curriculum Type:
                                <ul class="tagsList">
                                  {curriculamdata.length > 0 && curriculamdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagC(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("type") && (
                              <li class="tags">Type:
                                <ul class="tagsList">
                                  {typedata.length > 0 && typedata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagT(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("location") && (
                              <li class="tags">Location:
                                <ul class="tagsList">
                                  {locationdata != '' && (<li>{locationdata}<a onClick={e => this.onRemoveTagL(locationdata, e)}>x</a></li>)

                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("fees") && (
                              <li class="tags">Fees:
                                <ul class="tagsList">
                                  {feesdata.length > 0 && feesdata.map((item, i) => {
                                    return (<li>{'₹' + Number(item).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}<a onClick={e => this.onRemoveTagFees(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("ratings") && (
                              <li class="tags">Ratings:
                                <ul class="tagsList">
                                  {ratingsdata.length > 0 && ratingsdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagR(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("googleratings") && (
                              <li class="tags">Google Rating:
                                <ul class="tagsList">
                                  {googleratingsdata.length > 0 && googleratingsdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagGR(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("facilities") && (
                              <li class="tags">Facilities:
                                <ul class="tagsList">
                                  {facilitiesdata.length > 0 && facilitiesdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagF(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}
                            {filteredData.includes("distance") && (
                              <li class="tags">Distance:
                                <ul class="tagsList">
                                  {distancedata != '' && (<li>{distancedata} km<a onClick={e => this.onRemoveTagD(distancedata, e)}>x</a></li>)

                                  }
                                </ul>
                              </li>
                            )}

                          </ul>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              )}

              <div className="col-lg-3 mt-3 col-md-4 pl-md-0 d-none d-md-block">
                <div className='laning-stick'>
                  <div className="left-side-box">
                    <div className="left-head mob-col-wrap">
                      Schools
                      <button className="btn mob-collapse-btn pr-0 d-block d-md-none">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="left-side-body">
                      <ul>
                        {this.state.catelist.map((item, i) => {
                          let active;
                          if (this.state.active_cate == item.category_name) {
                            active = 'active';
                          } else {
                            active = '';
                          }
                          return (
                            <li onClick={() => this.handleSubCategory(item.slug_term)} className={active} data-tip data-for={`catetipM${i}`}>
                              {item.category_name} &nbsp;
                              {item.descrp && (
                                <span className='d-none d-md-block'>
                                  <i class="fa fa-info-circle"></i>
                                  <ReactTooltip id={`catetipM${i}`} place="bottom" effect="solid" className='custome-info-data'>
                                    <p style={{ textAlign: "left" }}>{item.descrp}</p>
                                  </ReactTooltip>
                                </span>)}
                            </li>
                          );
                        })}

                      </ul>
                    </div>
                  </div>
                  <div className="left-side-box">
                    <div className="left-head mob-col-wrap" data-title="Search Filters" data-intro="Use filters for best results!" >
                      {filtertitle} &nbsp; <img src="/assets/icons/animatedarrow.gif" class="arrowanimated" /> 
                      <button className="btn mob-collapse-btn pr-0 d-block d-md-none">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </button>
                    </div>
                    {this.filterFunction(2)}

                    <div className='filter-a1 text-center'>
                    <hr />
                    <button class="btn btn-theme btn-sm" style={{
                      background: 'rgb(245 209 112)',
                      color: '#fff'
                    }} onClick={e => this.clearFilter()}>Clear</button>
                    </div>
                  </div>
                  <div className="d-none d-md-block">
                    <LeadSmall pageinfo={pageinfo} param={topTrending}/>
                    <TopTrending param={topTrending} />
                    <ArticleSmall pageinfo={pageinfo} param={topTrending}/>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-8 mt-3">
                <div className="col-12 px-0 d-none d-md-block">
                 
                  <div class="topfilterflexbar">
                        <div class="flx_breadcrum">
                          <span className='mb4c'>
                            <b style={{ 'cursor': 'pointer' }} onClick={() => this.homeLink()}>Home&nbsp;<i class="fa fa-angle-right"></i>&nbsp;</b>
                            <b style={{ 'cursor': 'pointer' }} onClick={() => this.breadLinkHome()}>Schools&nbsp;<i class="fa fa-angle-right"></i>&nbsp;</b>
                            <b><span style={{ textTransform: 'capitalize' }}>{this.state.active_cate}</span></b>
                          </span>
                        </div>
                        
                        <div class="flx_sortby">
                        <div class="flx_soryby_inner">
                        <div className={this.state.sortby ? 'disflex' : 'disflex'}>
                            <div>Sort By</div><select className='form-control special landing-sort-drop selectpicker' name="sortby" value={this.state.sortby} onChange={this.handle_sortby_list}>
                            <option value="">Default Sort</option>
                            <option value="1">Name </option>
                            <option value="2">Location </option>
                            <option value="3">Rating</option>
                            <option value="4">Fee</option>
                          </select>
                        </div>
                        {this.state.sortby &&
                          (
                            <div className='col-md-1 p-0'>
                              <span className="tile-sort-icon" onClick={this.handle_Sortby}>
                                {(this.state.sortby_option == true) ?
                                  (<i class="fas fa-sort-amount-up" aria-hidden="true"></i>) :
                                  (<i class="fas fa-sort-amount-down" aria-hidden="true"></i>
                                  )}
                              </span>
                            </div>
                          )
                        }
                        <div className={this.state.sortby ? 'disflex' : 'disflex'}>
                        <div>Entries</div> <select className='form-control selectpicker special landing-sort-drop'
                            name="perpage" value={this.state.perpage} onChange={this.handlePerPage}>
                            <option value="15">15</option>
                            <option value="30">30 </option>
                            <option value="50">50</option>
                          </select>
                        </div>
                        </div>

                        </div>
                  </div>

                </div>
                <div className="col-lg-12 col-md-12">

                  <div class="row pageTitleH1" dangerouslySetInnerHTML={{__html:pagetitle}} />     

                  <div class="chooseeasyoption desktoponly">
                          <span class="itslabel">Curriculum :</span>
                          <span className={selectedCurOption =='All' ? "curtypeoption selected" : "curtypeoption"} data-text="All" data-id="All"  onClick={this.changeOption}>All</span>
                          <span className={selectedCurOption =='2' ? "curtypeoption selected" : "curtypeoption"}  data-text="CBSE" data-id="2" onClick={this.changeOption}>CBSE</span>
                          <span className={selectedCurOption =='1' ? "curtypeoption selected" : "curtypeoption"}  data-text="State Board" data-id="1" onClick={this.changeOption}>State Board</span>
                          <span className={selectedCurOption =='3' ? "curtypeoption selected" : "curtypeoption"}  data-text="ICSE" data-id="3" onClick={this.changeOption}>ICSE</span>
                          <span className={selectedCurOption =='5' ? "curtypeoption selected" : "curtypeoption"}  data-text="IB" data-id="5" onClick={this.changeOption}>IB</span>
                          <span className={selectedCurOption =='6' ? "curtypeoption selected" : "curtypeoption"}  data-text="NIOS" data-id="6" onClick={this.changeOption}>NIOS</span>
                  </div> 

                  <div class="chooseeasyoption  mobileonly">
                    <div class="cur_displayflex">
                          <div class="itslabel btm20px">Curriculum :</div>
                          <div class="dropdownlist">
                            <select name="curriculum_type" class="curtypeoption" onClick={this.changeSelectOption}>
                              <option className={selectedCurOption =='All' ? "curtypeoption selected" : "curtypeoption"} value="All" data-id="All">All</option>
                              <option className={selectedCurOption =='2' ? "curtypeoption selected" : "curtypeoption"}  value="CBSE" data-id="2">CBSE</option>
                              <option className={selectedCurOption =='1' ? "curtypeoption selected" : "curtypeoption"}  value="State Board" data-id="1" >State Board</option>
                              <option className={selectedCurOption =='3' ? "curtypeoption selected" : "curtypeoption"}  value="ICSE" data-id="3">ICSE</option>
                              <option className={selectedCurOption =='5' ? "curtypeoption selected" : "curtypeoption"}  value="IB" data-id="5">IB</option>
                              <option className={selectedCurOption =='6' ? "curtypeoption selected" : "curtypeoption"}  value="NIOS" data-id="6">NIOS</option>
                            </select>
                           </div>
                    </div>
                  </div>
                    

                  {this.paginationHtml()}

                  <div className='row'>
                    {this.state.filteredList.length === 0 && this.state.isloading === false && (
                      <p>Currently data doesn't exist, please get in touch if needed</p>
                    )}
                    
                    <AllVerticalSte1 pageinfo={pageinfo} />  

                    {this.state.isloading === true &&

                        <CardSkeleton cards={15} />
                      
                    }

                    {this.renderNewTile()}
                  </div>
                  <div className='mb-3'>
                    {this.paginationHtml()}
                  </div>
                                
                </div>
                <div className="d-block d-md-none">
                  <TopTrending param={topTrending} />
                </div>
              </div>

              <div className="mt-3 col-md-1 pl-md-2 m-hide-ads">
                <div className='laning-stick'>
                  { /*<SchoolRight /> */ }
                  <div class="row mb-5 landing-right-ad">  
                    <AdsDynamicRightPosition1 params={page}/>
                  </div>
                  <div class="row landing-right-ad">  
                  <AdsDynamicRightPosition2 params={page}/>
                  </div> 
                </div>
              </div>
            </div>
            <AdsDynamicBottom/> 
            { /* <AdsHorizandal /> */ }
            <div class="row desktoponly">
              <div class="col-lg-12 ">
                <div class="specialcontent" dangerouslySetInnerHTML={{ __html: this.state.schoolSEOContent}}></div>
              </div>
            </div>  
            <div class="row mobileonly">
              <div class="col-lg-12 ">
                <div class="specialcontent" dangerouslySetInnerHTML={{ __html: this.state.schoolSEOContent}}></div>
              </div>
            </div>  

          </div>
        </section>

        <Modal isOpen={this.state.showcp} centered size='lg'>

<ModalBody>
  <h4 class='csph4'>Contact {this.state.schoolName}</h4>
  <button
    className='close-btn'
    data-dismiss='modal'
    aria-label='Close'
    onClick={this.handleCloseCp}
  >
    <img src={closebtn} alt='close' />
  </button>
  <div class="formbox csp">
    <form
      method='post'
      onSubmit={this.handleSubmitEnquiry}
      autoComplete='off'
      id='loginForm'
    >
      <div
        className='form-group has-feedback'
        style={{ width: '55%', float: 'left' }}
      >
        <label className='n7tr' >
          First Name
        </label>
        <input
          type='text'
          name='first_name'
          className='form-control' onChange={this.handleChange} required
        />

      </div>
      <div
        className='form-group has-feedback'
        style={{ width: '40%', float: 'right' }}
      >
        <label className='n7tr' >
          Last Name
        </label>
        <input
          type='text'
          name='last_name'
          className='form-control'  onChange={this.handleChange}  required
        />

      </div>
      <div className='form-group has-feedback'>
        <label className='n7tr'>
          Mobile Number
        </label>
        <input
          type='text'
          name='reg_mobile'
          className='form-control'  onChange={this.handleChange}  required
        />

      </div>
      <div className='form-group has-feedback'>
        <label className='n7tr'>
          Email ID
        </label>
        <input
          type='text'
          name='reg_email'
          className='form-control'  onChange={this.handleChange}  value={this.state.email_id} required
        />

      </div>

      <div className='form-group has-feedback'>
        <label className='n7tr'>
          Any Message
        </label>
        <textarea

          name='any_message'
          value={this.state.any_message}  onChange={this.handleChange} 

          className='form-control' required
        />
      </div>

      <div className='form-group has-feedback'>
        <input
          type='submit'
          name='submit'
          value='Submit'
          className='submit btn btn-primary btn-block btn-css'
        />
      </div>
    </form>
  </div>
</ModalBody>

        </Modal>


        <Footer />
      </React.Fragment>
    );
  }
  renderNewTile() {
    return this.state.pageOfItems.map((item, index) => {

      return (
        
        <React.Fragment>
          {this.showAd(index)}
          {SCREEN_SIZE < 768 ?
            <Link className='tile-link' to={'/' + this.state.city + '/schools/' + this.state.subcategory + '/' + item.path_term} onClick={() => this.sub_cate()}>
              {this.getContentMobile(item)}
            </Link>
            :
            this.getContent(item)
          }

        </React.Fragment>
      );
    });
  }


  

  showAd=(index) =>{

     return (
        <> {index==7 &&
                <AdsDynamicMobileMiddle/>
              }
        </>
     )
      

  }

  getContentMobile = (item) => {
    let fee = item.avg_fee != 0 ? '₹' + Number(item.avg_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? 'hidden' : '';
    let isDesk = SCREEN_SIZE > 767 ? 'hidden' : '';
    let wishlist = {
      category_id: 1,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href
    }
    let compare = {
      id: item._id,
      type: 'school',
      keyword: 'school_compare'
    }
    let stamped ='';
    if(item.stamp_img){
      stamped='premiumuser ';
    }

    let orgphoto = '';
    let orgphotos = (item.photos!='') ? item.photos.split(","):[];

    if(orgphotos.length==0){
        orgphoto = '/assets/images/school-default.png';
    }else{
        orgphoto = AZ_ASSET_PATH+orgphotos[0];
    }

    let regonly = 0;
    let regonlyorpaidalso = 0;

    if(item.vendor_id>=1 && stamped!=''){
        regonlyorpaidalso = 1;
    }

    if(item.vendor_id>=1 && stamped==''){
      regonly = 1;
    }

    return (
      <div className={stamped + ' tilerow mobileview'}>
        <div className='newtile'>
            <div className='rowflex'>
              <div className='orgbg' style={{backgroundImage:`url(`+orgphoto+`)`}} >
              { item.stamp_img!='' &&
                <div className='tile-stamp-sec col-12'>
                  <img className='tile-stamp-img' src={stampedicon} />
                </div>
              }
              </div>
              <div className='newtile-info'>
                <div className='tile-detail-sec tile-title row align-items-center inst_displayflex'>
                  <div className='inst_name'>
                    <p className='text-wrap'>{item.schoolName}</p>
                  </div>
                  <div className='displayflex'>
                       
                      { regonly==1 &&
                       <div className="tile-btn-biew">
                        <button className='btn btn-sm btn-primary' data-name={item.schoolName} data-id={item.id} onClick={this.enquireThisRegOnly}>Enquire Now</button>
                      </div>
                      }

                      { regonlyorpaidalso==1 &&
                       <div className="tile-btn-biew">
                        <button className='btn btn-sm btn-primary' data-name={item.schoolName} data-id={item.id} onClick={this.enquireThisPaidOnly}>Enquire Now</button>
                      </div>
                      }

                    <div className='tile-btn-biew pull-right'>
                      
                      <Link target="_blank" to={'/' + this.state.city + '/schools/' + this.state.subcategory + '/' + item.path_term} onClick={() => this.sub_cate()}>
                        <button className='btn btn-sm btn-primary'>More Info</button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className='tile-detail-sec tile-adrs row'>
                  {this.state.isEschool &&
                    <p className='text-wrap'>E-School</p>
                  }
                  {!this.state.isEschool &&
                    <p className='text-wrap'>{item.address}</p>
                  }
                </div>
                <div className='tile-detail-sec align-items-center row'>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-distance badge badge-secondary'>
                      <p className='text-wrap'>
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i></span>&nbsp;
                        {!this.state.isEschool && <span>{parseFloat(item.distance).toFixed(1)} KM </span>}&nbsp;
                        <span title={item.area_name}>{item.area_name}</span>
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0 d-flex justify-content-center'>
                    <div className='tile-rate badge badge-secondary'>
                      <p className='text-wrap'>
                        <span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;</span>
                        <span>{item.rating ? item.rating : '0.0'}</span>
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-compare' onClick={(e) => this.addToCompare(e, compare)}>
                      <img src={compareicon} />&nbsp;Compare
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-wish' onClick={(e) => this.addTowishList(e, wishlist)}>
                      <img src={actionicon3} />&nbsp; Wishlist
                    </div>
                  </div>
                </div>
                <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                  <div className='col col-xs-4 p-0'>
                    <label>Category</label>
                    <p>{this.state.active_cate}</p>
                  </div>
                  <div className='col col-xs-4 p-0'>
                    <label>Board </label>
                    <p>{item.boe}</p>
                  </div>

                  {(item.current_vacancies!=null && !item.stamp_img) &&
                  <div className='col col-xs-3 p-0'>
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>{item.current_vacancies}</p>
                  </div>
                  }

                  {(item.current_vacancies!=null && item.stamp_img) &&
                   <div className='col col-xs-3 p-0'>
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                  }

                  <div className='col col-xs-4 p-0'>
                    <label>Annual Fee (Indicative)</label>
                    <p>{fee}</p>
                  </div>
                </div>
              </div>
              <div className={`col-12 ${isDesk}`}>
                <div className='tile-detail-sec tile-details row'>
                  <div className='col p-0'>
                    <label>Category</label>
                    <p>{this.state.active_cate}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Board </label>
                    <p>{item.boe}</p>
                  </div>

                   {(item.current_vacancies!=null && !item.stamp_img) &&
                  <div className='col p-0'>
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>{item.current_vacancies}</p>
                  </div>
                  }

                  {(item.current_vacancies!=null && item.stamp_img) &&
                   <div className='col p-0'>
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                  }


                  <div className='col p-0'>
                    <label>Annual Fee (Indicative)</label>
                    <p>{fee}</p>
                  </div>
                </div>
               
            </div>
          </div>
          
          <div className='rowflex'>
                <div className='tile-seo-tag'>
                  <div className={`${isMobile} tile-seo-tag-desk`}>
                    {item.keywords.map((data) => {
                      return (<span class="badge badge-defult">{data}</span>)
                    })}
                  </div>
                  <div className={`${isDesk} tile-seo-tag-mob`}>
                    {item.keywords.map((data) => {
                      return (<span class="badge badge-defult">{data}</span>)
                    })}
                  </div>
                </div>
          </div>
        </div>
      </div>
    )
  }

  checkIfImageExists(url, callback) {
    const img = new Image();
    img.src = url;
    
    if (img.complete) {
      callback(true);
    } else {
      img.onload = () => {
        callback(true);
      };
      
      img.onerror = () => {
        callback(false);
      };
    }
  }

  getContent = (item) => {
    let fee = item.avg_fee != 0 ? '₹' + Number(item.avg_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? 'hidden' : '';
    let isDesk = SCREEN_SIZE > 767 ? 'hidden' : '';
    let wishlist = {
      category_id: 1,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href
    }
    let compare = {
      id: item._id,
      type: 'school',
      keyword: 'school_compare'
    }
    let stamped ='';
    if(item.stamp_img){
      stamped='premiumuser ';
    }

    let orgphoto = '';
    let orgphotos = (item.photos!='') ? item.photos.split(","):[];

    if(orgphotos.length==0){
        orgphoto = '/assets/images/school-default.png';
    }else{
        //orgphoto = 'https://api.bewise.in/'+orgphotos[0];
        orgphoto = AZ_ASSET_PATH+orgphotos[0];
  
    }

    const img = new Image();
    img.src = orgphoto;

    if (img.complete) {
      orgphoto = orgphoto;
    }else{
      orgphoto = '/assets/images/school-default.png';
    }

    let regonly = 0;
    let regonlyorpaidalso = 0;

    if(item.vendor_id>1 && stamped!=''){
        regonlyorpaidalso = 1;
    }
    else{
      regonlyorpaidalso = 0;
    }

    if(item.vendor_id>1 && stamped==''){
      regonly = 1;
    }
    else{
      regonly=0;
    }

    return (
      <div className={stamped + ' tilerow '}>
        <div className='newtile'>
            <div className='rowflex'>
               
              <div className='newtile-img orgimg_desktop' style={{backgroundImage:`url(`+orgphoto+`)`}}>&nbsp;</div>
                
              <div className='newtile-info'>
                <div className='tile-detail-sec tile-title row align-items-center inst_displayflex'>
                  <div className='inst_name'>
                    <p className='text-wrap'>{item.schoolName}</p>
                  </div>
                  <div className='displayflex justflex'>
                    { stamped!='' &&
                    <div className='stampmoved'>
                     <div class="premiumstamp"><img src="/assets/images/stamp.png" /></div>
                    </div>
                    }
                    { regonly==1 &&
                      <div class="tile-btn-biew button">
                        <button className='btn btn-sm btn-primary' data-name={item.schoolName} data-id={item.id} onClick={this.enquireThisRegOnly}>Enquire Now</button>
                      </div>
                      }

                      { regonlyorpaidalso==1 &&
                      <div class="tile-btn-biew button">
                        <button className='btn btn-sm btn-primary' data-name={item.schoolName} data-id={item.id} onClick={this.enquireThisPaidOnly}>Enquire Now</button>
                      </div>
                      }
                    <div className='tile-btn-biew pull-right'>
                      <Link target="_blank" to={'/' + this.state.city + '/schools/' + this.state.subcategory + '/' + item.path_term} onClick={() => this.sub_cate()}>
                        <button className='btn btn-sm btn-primary'>More Info</button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className='tile-detail-sec tile-adrs row'>
                  {this.state.isEschool &&
                    <p className='text-wrap'>E-School</p>
                  }
                  {!this.state.isEschool &&
                    <p className='text-wrap'>{item.address}</p>
                  }
                </div>
                <div className='tile-detail-sec align-items-center row'>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-distance badge badge-secondary'>
                      <p className='text-wrap'>
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i></span>&nbsp;
                        {!this.state.isEschool && <span>{parseFloat(item.distance).toFixed(1)} KM </span>}&nbsp;
                        <span title={item.area_name}>{item.area_name}</span>
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0 d-flex justify-content-center'>
                    <div className='tile-rate badge badge-secondary'>
                      <p className='text-wrap'>
                        <span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;</span>
                        <span>{item.rating ? item.rating : '0.0'}</span>
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-compare' onClick={(e) => this.addToCompare(e, compare)}>
                      <img src={compareicon} />&nbsp;Compare
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-wish' onClick={(e) => this.addTowishList(e, wishlist)}>
                      <img src={actionicon3} />&nbsp; Wishlist
                    </div>
                  </div>
                </div>
                <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                  <div className='col col-xs-4 p-0'>
                    <label>Category</label>
                    <p>{this.state.active_cate}</p>
                  </div>
                  <div className='col col-xs-4 p-0'>
                    <label>Board </label>
                    <p>{item.boe}</p>
                  </div>

                  {(item.current_vacancies!=null && !item.stamp_img) &&
                  <div className='col col-xs-3 p-0'>
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>{item.current_vacancies}</p>
                  </div>
                  }

                  {(item.current_vacancies!=null && item.stamp_img) &&
                   <div className='col col-xs-3 p-0'>
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                  }

                  <div className='col col-xs-4 p-0'>
                    <label>Annual Fee (Indicative)</label>
                    <p>{fee}</p>
                  </div>
                </div>
              </div>
              <div className={`col-12 ${isDesk}`}>
                <div className='tile-detail-sec tile-details row'>
                  <div className='col p-0'>
                    <label>Category</label>
                    <p>{this.state.active_cate}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Board </label>
                    <p>{item.boe}</p>
                  </div>

                   {(item.current_vacancies!=null && !item.stamp_img) &&
                  <div className='col p-0'>
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>{item.current_vacancies}</p>
                  </div>
                  }

                  {(item.current_vacancies!=null && item.stamp_img) &&
                   <div className='col p-0'>
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                  }


                  <div className='col p-0'>
                    <label>Annual Fee (Indicative)</label>
                    <p>{fee}</p>
                  </div>
                </div>
               
            </div>
          </div>
          
          <div className='rowflex'>
                <div className='tile-seo-tag'>
                  <div className={`${isMobile} tile-seo-tag-desk`}>
                    {item.keywords.map((data) => {
                      return (<span class="badge badge-defult">{data}</span>)
                    })}
                  </div>
                  <div className={`${isDesk} tile-seo-tag-mob`}>
                    {item.keywords.map((data) => {
                      return (<span class="badge badge-defult">{data}</span>)
                    })}
                  </div>
                </div>
          </div>
        </div>
      </div>
    )
  }
  addTowishList = async (e, data) => {
    e.preventDefault();
    let logged_auth = this.state.logged_auth;
    if (logged_auth == 'true') {
      await addToWishList(data);
    } else {
      this.setState({
        openModalLogin: true
      })
    }
  }
  addToCompare = async (e, data) => {
    e.preventDefault();
    let logged_auth = this.state.logged_auth;
    if (logged_auth == 'true') {
      await addToCompareList(data);
    } else {
      this.setState({
        openModalLogin: true
      })
    }
  }
  renderList() {
    return this.state.pageOfItems.map((item, index) => {
      let fee = item.avg_fee != 0 ? '₹' + Number(item.avg_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';

      if(index==2){
        return (
          <div class="col-sm-6 col-md-6 col-xl-4 col-lg-6 mobilebanners">Ad banner</div>
        )
      }
      return (
        <div className='col-sm-6 col-md-6 col-xl-4 col-lg-6 hover1' style={{ padding: 10 }} key={item._id}>
          <div
            className='img-school s6g6bd'
            style={{ backgroundImage: `url('${item.images ? item.images : '../assets/icons/1.png'}')` }}
          >
            <div className="conntent-bottom">
              <div className='r5b99d'>
                <span className='g4yb'>{item.schoolName}</span>
              </div>
              <div className='u0865'>
                <div className='gf5-review'>
                  <div className='n6cd-r'>
                    <img
                      src={BASE_URL + 'assets/icons/review-star.png'}
                      className='star-r'
                      alt='star  '
                    />
                  </div>
                  {<div className='v5dfa'>{item.rating ? item.rating : '0.0'}</div>}
                </div>
                <div className='f5va-label'>
                  <i className='fas fa-map-marker-alt custom'></i>{' '}
                  <span>&nbsp;{parseFloat(item.distance).toFixed(1)} km</span>
                </div>
              </div>
            </div>
          </div>
          <div className='overlay'>
            <div className='text'>
              <div className='row'>
                <div className={item.stamp_img ? 'col-md-9' : 'col-md-12'}>
                  <h6 className='school-n6f'>{item.schoolName}</h6>
                </div>
                {item.stamp_img &&
                  <div className='col-md-3 stamp-sec'>
                    <img src={IMG_URL + item.stamp_img} />
                  </div>
                }
              </div>
              <p>
                <span className='n7v5'>Place</span> : {item.location}
              </p>
              <p>
                <span className='n7v5'>Board</span> : {this.state.active_cate}
              </p>
              <p>
                <span className='n7v5'>Established Year</span> : {item.est_year}
              </p>

              <p>
                <span className='n7v5'>Indicative Annual Fee </span> : {fee}
              </p>

              <Link to={'/' + this.state.city + '/schools/' + this.state.subcategory + '/' + item.path_term} onClick={() => this.sub_cate()}>
                <button className='btn hover-btn'>View More</button>
              </Link>
            </div>
          </div>
        </div>
      );
    });
  }
  filterFunction = (type) => {

    return (
      <div className="left-side-body">
        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>Curriculum Type</p>
          </div>
          <div
            className={'arrow-head fa ' + this.state.curriculam_arrow}
            onClick={this.handle_Curriculam}
          ></div>
        </div>

        <div className='filter-a1'>
          {this.state.curriculam_option === true ? (
            <ul className='f-li-none'>
              {this.state.categorySubTypeList.length > 0 &&
                this.state.categorySubTypeList.map((item, i) => {

                  let checkedarray = sessionStorage.getItem('curriculam_ids').split(',');
                  let check = (checkedarray.includes(item.id.toString())) ? 'checked' : '';
                  let disabled = (this.state.scat=='school-special-needs' || this.state.scat=='open-schools' || this.state.scat=='alternative-schools') ? true:false 
                   
                  return (
                    <li>
                      <input
                        type='checkbox'
                        dataselected={check}
                        disabled={disabled}
                        onChange={this.handleCurriculamCheckbox}
                        name='curriculam'
                        id={"checkbox-"+i}
                        value={item.id}
                        datatext={item.name}
                        defaultChecked={check}
                      />
                      {item.name}
                    </li>
                  )

                })}

            </ul>
          ) : (
            ''
          )}
        </div>

        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>School Type</p>
          </div>
          <div
            className={'arrow-head fa ' + this.state.type_arrow}
            onClick={this.handle_Type}
          ></div>
        </div>

        <div className='filter-a1'>
          {this.state.type_option === true ? (
            <ul className='f-li-none'>
              {this.state.categorySubTypesList.length > 0 &&
                this.state.categorySubTypesList.map((item, i) => {

                  let checkedarray = sessionStorage.getItem('type_ids').split(',');
                  let check = (checkedarray.includes(item.id.toString())) ? 'checked' : '';
                  //let check = (this.state.selectedType.includes(item.id.toString())) ? 'checked' : '';
                  return (
                    <li>
                      <input
                        type='checkbox'
                        onChange={this.handleTypeCheckbox}
                        name='type'
                        value={item.id}
                        datatext={item.name}
                        defaultChecked={check}
                      />
                      {item.name}
                    </li>
                  )

                })}

            </ul>
          ) : (
            ''
          )}
        </div>

        <div className={this.state.isEschool?'hidden':'f-b6fd'}>
          <div className='n8ds-head'>
            <p>{FIL_DIS} <i class="fa fa-info-circle" data-tip data-for="registerTip"></i></p>
          </div>
          <div className="App">
            <ReactTooltip id="registerTip" place="bottom" effect="solid" className='react_tooltip_location'>
              <p style={{ textAlign: "left" }}>Default location is {this.state.centerLocation}.<br /> Please choose your own for sharper results.</p>
            </ReactTooltip></div>
          <div
            className={'arrow-head fa ' + this.state.dis_arrow}
            onClick={this.handle_Distance}
          ></div>
        </div>
        {this.state.distance_option === true ? (
          <div className='filter-a1' id="myRangeDistanceWrap">
            <PlacesAutocomplete
              value={this.state.address}
              className="form-control"
              searchOptions={{
                //location: new window.google.maps.LatLng(localStorage.getItem("latitude"), localStorage.getItem("longitude")),
                //radius: 15000,
                //bounds: bangaloreBounds,
                types: ['locality','sublocality', 'postal_code', 'administrative_area_level_1','administrative_area_level_2'],
                strictbounds: true,
                componentRestrictions: {
                  country: 'in'
                }
              }}
              /*
              searchOptions={{
                location: new window.google.maps.LatLng(localStorage.getItem("latitude"), localStorage.getItem("longitude")),
                radius: 15000,
                types: ['address'],
                strictbounds: true,
                componentRestrictions: {
                  country: 'in'
                }
              }}*/

              onChange={this.handleplaceChange}
              onSelect={this.handleplaceSelect}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div >
                  <input
                    {...getInputProps({
                      placeholder: 'Input Location ...',
                      className: 'form-control locationdatainput',

                    })}
                    value={this.state.address}
                  />
                  <div className="autocomplete-dropdown-container"
                    style={{ position: "absolute", zIndex: "999" }}>
                    {loading && <div>Loading...</div>}
                    {console.log("suggessions", suggestions)}
                    {suggestions.map(suggestion => {
                      const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', cursor: 'pointer' };


                      //if((this.state.current_location.toLowerCase()=='bengaluru' && suggestion.formattedSuggestion.secondaryText.match(/Bengaluru.*/)) || (this.state.current_location.toLowerCase()=='chennai' && suggestion.formattedSuggestion.secondaryText.match(/Chennai.*/))){
                     
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                     // }
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>


            <div className='f-nydf range-wrap' >
              <p className="range-text"><span className="col">0</span> <span className="col text-center">To</span> <span className="col text-right">{MAXDIS_FILP}</span></p>
              <input
                id="myRangeDistance"
                type="range"
                name='disRange'
                className='slider'
                min="0" max={this.state.disMax}
                value={(sessionStorage.getItem('distance')) ? sessionStorage.getItem('distance').toString() : this.state.distance}
                onChange={this.handleDistanceChange}
                step="1" />
              <output className="bubble" style={{ 'left': 'calc(96% + -0.5px)' }}>{(sessionStorage.getItem('distance')) ? sessionStorage.getItem('distance').toString() : this.state.distance}</output>

            </div>

          </div>) : ('')}

        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>{FIL_FEEP}</p>
          </div>
          <div
            className={'arrow-head fa ' + this.state.fee_arrow}
            onClick={this.handle_Fees}
          ></div>
        </div>

        <div className='filter-a1'>
          {this.state.fees_option === true ? (

            <div className='f-nydf range-wrap' id="myRangeAnnualFeeWrap">
              <p className="range-text"><span className="col">0</span> <span className="col text-center">To</span> <span className="col text-right">{MAXFEE_FILPlay}</span></p>
              <input
                id="myRangeAnnualFee"
                type="range"
                className='slider'
                name="fee_range"
                min="0" max={this.state.priceMax}
                value={(sessionStorage.getItem('fees_texts') != '') ? sessionStorage.getItem('fees_texts').toString() : this.state.annual_fee}
                onChange={this.handleAnnualfeeChange}
                step="1" />
              <output className="bubble" style={{ 'left': 'calc(90% + -0.5px)' }}>{(sessionStorage.getItem('fees_texts') != '') ? sessionStorage.getItem('fees_texts').toString() : this.state.annual_fee}</output>

            </div>
          ) : (
            ''
          )}
        </div>
        <div className='f-b6fd'>
          <div className='n8ds-head'><p>Rating @ BeWise</p></div>
          <div
            className={'arrow-head fa ' + this.state.review_arrow}
            onClick={this.handle_Review}
          ></div>
        </div>
        <div className='filter-a1 bewise-range-color'>
          {this.state.review_option === true ? (
            <div className='f-nydf range-wrap' id="myRangeReviewWrap">
              <p className="range-text"><span className="col">0</span>
                <span className="col text-center"></span> <span className="col text-right">5</span></p>
              <input
                id="myRangeReview"
                type="range"
                className='slider'
                name="review"
                min="0" max='5'
                value={this.state.review}
                onChange={this.handleRatingChange}
                step="1" />
              <output className="bubble" style={{ left: 'calc(0% + 8px)' }}>{this.state.review == 5 ? this.state.review : this.state.review + '+'}</output>
            </div>) : ''}

        </div>

        <div className='f-b6fd'>
          <div className='n8ds-head'><p>{RATING_GOOGLE}</p></div>
          <div
            className={'arrow-head fa ' + this.state.reviews_arrow}
            onClick={this.handle_Reviews}
          ></div>
        </div>
        <div className='filter-a1 bewise-range-color'>
          {this.state.reviews_option === true ? (
            <div className='f-nydf range-wrap' id="myRangeSocialRatingWrap">
              <p className="range-text"><span className="col">0</span>
                <span className="col text-center"></span> <span className="col text-right">5</span></p>
              <input
                id="myRangeSocialRating"
                type="range"
                className='slider'
                name="review_social"
                min="0" max='5'
                value={this.state.review_social}
                onChange={this.onStarClickSocial}
                step="1" />
              <output className="bubble" style={{ left: 'calc(4% + 4.25px)' }}>{this.state.review_social == 5 ? this.state.review_social : this.state.review_social + '+'}</output>
            </div>) : ''}
        </div>

        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>Facilities</p>
          </div>
          <div
            className={'arrow-head fa ' + this.state.fac_arrow}
            onClick={this.handle_Facilities}
          ></div>
        </div>
        <div className='filter-a1'>
          {this.state.facilities_option === true ? (
            <ul className='f-li-none'>
              {this.state.facilitesList.length > 0 &&
                this.state.facilitesList.map((item, i) => {

                  let checkedarray = sessionStorage.getItem('facilities_ids').split(',');
                  let check = (checkedarray.includes(item.id.toString())) ? 'checked' : '';

                  return (
                    <li key={i}>
                      <input
                        type='checkbox'
                        onChange={this.handleFacilitiesChange}
                        name='facilities'
                        value={item.id}
                        datatext={item.facility}
                        defaultChecked={check}
                      />
                      {item.facility}
                    </li>
                  )

                })}
            </ul>
          ) : (
            ''
          )}
        </div>

        {/* <div className='f-b6fd'>
                      <div className='n8ds-head'>
                        <p>Classification</p>
                      </div>
                      <div
                        className={'arrow-head fa ' + this.state.classification_arrow}
                        onClick={this.handle_Classification}
                      ></div>
                    </div> */}

        <div className='filter-a1'>
          {this.state.classification_option === true ? (
            <ul className='f-li-none'>
              {this.state.classificationList.length > 0 &&
                this.state.classificationList.map((item, i) => {
                  let check = (this.state.selectedClassification.includes(item.id.toString())) ? 'checked' : '';
                  return (
                    <li>
                      <input
                        type='checkbox'
                        onChange={this.handleClassCheckbox}
                        name='classification'
                        value={item.id}
                        defaultChecked={check}
                      />
                      {item.name}
                    </li>
                  )
                })}

            </ul>
          ) : (
            ''
          )}
        </div>
        { /* type == 1 ? (
          <div className='filter-a1 text-center'>
            <hr />
            <button class="btn btn-theme btn-sm" style={{
              background: 'rgb(245 209 112)',
              color: '#fff'
            }} onClick={this.filterToogle}>Apply</button>
          </div>
        ) :
          (
            <div className='filter-a1 text-center'>
              <hr />
              <button class="btn btn-theme btn-sm" style={{
                background: 'rgb(245 209 112)',
                color: '#fff'
              }} onClick={this.handle_clearFilter}>Clear Filter</button>
            </div>
          ) */ }

      </div>
      
      
    )
  }
  paginationHtml = () => {
    if (this.state.pageOfItems.length > 0)
      return (
        <div className='middlelist row paginations'>
          <div class="col-8 p-0" ><div className="pageof">{this.state.pageindex} of {this.state.totalsplitpages} Pages<span className="totalrecordsinfo">({this.state.totalrecords} total records)</span></div></div>
          <div class="col-4 p-0">
            <div class="pull-right">
              <div className={this.state.pgnumber == 0 ? "previouslist hidden" : "previouslist"} onClick={() => this.onChangePrevPage(this.state.pgnumber)}>
                <div class="vertical-prev">Prev</div>
              </div>
              <div className={this.state.pageindex == this.state.totalsplitpages ? "nextlist hidden" : "nextlist"}  onClick={() => this.onChangeNextPage(this.state.pgnumber)}>
                <div class="vertical-next">Next</div>
              </div>
            </div>
          </div>
        </div>
      )
  }
}



export default SchoolPage;
